exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LiveLogNoticeBar-b44422c2{padding:0 40px;text-align:center}.LiveLogNoticeBar-b44422c2 a{font-weight:500}.friendsCount-39dca157{margin-bottom:20px;color:#757575}.photoGrid-389e5854{margin:-6px -6px}.photoGrid-389e5854:after{content:'';display:table;clear:both}.recentPhoto-1517e7b1{display:block;float:left;margin:6px}.orgLink-abb58598{display:flex;margin-bottom:10px}.orgLink-abb58598 img{margin-right:15px;border:1px solid #e0e0e0}.orgLink-abb58598 .orgLocation-db12ba1c{color:#757575;font-size:13px}a.orgLink-abb58598,a.orgLink-abb58598:hover,a.orgLink-abb58598:visited,a.orgLink-abb58598:focus,a.orgLink-abb58598:active{color:inherit;text-decoration:none}\n", ""]);

// Exports
exports.locals = {
	"LiveLogNoticeBar": "LiveLogNoticeBar-b44422c2",
	"friendsCount": "friendsCount-39dca157",
	"photoGrid": "photoGrid-389e5854",
	"recentPhoto": "recentPhoto-1517e7b1",
	"orgLink": "orgLink-abb58598",
	"orgLocation": "orgLocation-db12ba1c"
};